import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import './NotificationPanel.css';
import CHECK from './images/check.svg';
import DOUBLE_CHECK from './images/double-check.svg';
import config from 'config';
import NoticeboardAPICall from 'NoticeboardAPICall';
import { useDispatch, useSelector } from "react-redux";

function NotificationPanel(props) {

    let shouldWait = false;
    let scrollBuffer = 0;

    const [showPanel, setShowPanel] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [pageIndex, setPageIndex] = useState(1);
    const [offset, setOffset] = useState(0);
    const [read, setRead] = useState(false);
    const [sortedIdArray, setSortedIdArray] = useState([]);
    const [selectedIdArray, setSelectedIdArray] = useState([]);
    const [totalCount, setTotalCount] = useState([]);
    const [instituteIdArray, setInstituteIdArray] = useState([]);
    const [notificationList, setNotificationList] = useState([]);
    const [unReadMessageCount, setUnReadMessageCount] = useState([]);

    const dispatch = useDispatch();
    const AdminAccessReducer = useSelector((state) => state.AdminAccessReducer);
    const routingMenu = useSelector((state) => state.RouteMenuReducer);

    useEffect(() => {
        apiCallToGetWebNotification();
        document.getElementById('notification-container-99').addEventListener('scroll', handleScroll);
        return (() => { document.getElementById('notification-container-99').removeEventListener('scroll', handleScroll) });
    }, []);

    useEffect(() => { if (props.notificationModal != showPanel) { setShowPanel(props.notificationModal) } }, [props.notificationModal]);
    
    useEffect(() => { apiCallToGetWebNotification(); }, [limit, routingMenu]);
    
    const loadMore = () => setLimit((prev) => prev + 10); // FUNCTION TO LOAD MORE
    
    const handleShowPanel = () => showPanel && setShowPanel(false)

    window.addEventListener('click', event => !document.getElementById('notification-container-99').contains(event.target) && handleShowPanel());

    const handleScroll = () => {
        let offsetHeight = document.getElementById('notification-container-99').offsetHeight;
        let scrollTop = document.getElementById('notification-container-99').scrollTop;
        if (scrollTop == 0) { scrollBuffer = 0; }
        if (((scrollTop - (scrollBuffer)) <= 0) || (Math.floor(offsetHeight / 3) > scrollTop)) return;
        scrollBuffer = scrollTop;
    }

    //  API CALL TO GET NOTIFICATION
    const apiCallToGetWebNotification = async () => {
        setIsLoading(true);


        const userRole = ["instructor", "employee", "teaching", "nonteaching"].includes(config.userRole) ? "instructor" : "learner";
        
        const formData = {
            iid: config.institute_id,
            userRole: userRole,
            userId: userRole == "instructor" ? config.faculty_id : config.studentId,
            offset: offset,
            limit: limit,
            iidArray: routingMenu.instituteIdArray, // AdminAccessReducer.iidArray.iidArray
        };

        try {
            const jsonResponse = await NoticeboardAPICall.makeApiCall(
                "webNotificationGetNotification",
                formData,
                '/api/webNotification/webNotification.php'
            );

            if (jsonResponse.expired) {
                setTimeout(apiCallToGetWebNotification, 1000);
            } else {
                if (jsonResponse.success) {
                    const { data, unReadMessageCount, totalCount, sortedIdArray } = jsonResponse.APIResult;
                    setUnReadMessageCount(unReadMessageCount);
                    setNotificationList(data);
                    setSortedIdArray(sortedIdArray);
                    setTotalCount(totalCount);
                    setSelectedIdArray([]);
                }
            }
        } catch (error) {
            console.error("Error in apiCallToGetWebNotification:", error);
        } finally {
            setIsLoading(false);
        }
    };

    //  API CALL TO UPDATE NOTIFICATION
    const apiCallToUpdateWebNotification = async (uniqueId) => {
        // Update selectedIdArray
        if (!selectedIdArray.includes(uniqueId)) {
            setSelectedIdArray([...selectedIdArray, uniqueId]);
        }

        const formData = {
            iid: config.institute_id,
            uniqueId: uniqueId,
            userId: config.faculty_id,
        };

        try {
            const jsonResponse = await NoticeboardAPICall.makeApiCall(
                "webNotificationUpdateNotification",
                formData,
                '/api/webNotification/webNotification.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    apiCallToUpdateWebNotification(uniqueId);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    apiCallToGetWebNotification();
                }
            }
        } catch (error) {
            // Handle errors here
            console.error("Error in apiCallToUpdateWebNotification:", error);
        }
    };

    const getFirstCharOfWords = (inputString) => {
        const wordsArray = inputString.split(' ');
        const firstCharsArray = wordsArray.map((word) => word.charAt(0));
        const result = firstCharsArray.join('');
        return result;
    }

    return (
        <div className="position-relative">
            <div
                className="mr-3 p-1 cursor-pointer"
                onClick={(e) => {
                    e.stopPropagation();
                    setShowPanel(prev => !prev);
                    props.handleModalOpenClose("notification")
                }}
            >
                {
                    Boolean(unReadMessageCount) &&
                    <span
                        className="position-absolute text-danger d-flex justify-content-center align-items-center shadow-sm bg-white"
                        style={{ borderRadius: '50%', width: '18px', height: '18px', top: '-5px', left: '10px', fontSize: '10px' }}
                    >{unReadMessageCount < 99 ? unReadMessageCount : "99+"}</span>
                }
                <FontAwesomeIcon className='text-white' size="lg" icon={['fas', 'bell']} />
            </div>
            <div style={{
                width: showPanel ? '100vw' : '0',
                height: showPanel ? '100vh' : '0',
                backgroundColor: showPanel ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
                zIndex: showPanel ? 19 : -1,
                position: 'fixed',
                top: 0,
                left: 0
            }} >

                <div
                    className="p-4 position-absolute d-flex flex-column transition shadow border bg-white"
                    style={{
                        width: "30vw",
                        height: showPanel ? '100vh' : '0',
                        // maxHeight: showPanel ? 'calc(100vh - 75px)' : 0,
                        opacity: showPanel ? '1' : '0',
                        right: showPanel ? '0' : '0',
                        // top: '40px', right: showPanel ? '-310px' : '-8000px',
                        zIndex: showPanel ? 20 : -1,
                        // zIndex: 20,
                        borderRadius: '0.7rem',
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: "space-between" }}>
                        <span className="font-weight-bold">Notifications</span>
                        <FontAwesomeIcon
                            className="export-icon mr-3 "
                            style={{ cursor: 'pointer' }}
                            onClick={() => { setShowPanel(prev => !prev); }}
                            icon={['fas', 'times']}
                            size="lg"
                        />
                    </div>
                    <div
                        id='notification-container-99' className='pr-2 mt-3 d-flex flex-column scrollable'
                        style={{ height: 'calc(100% - 100px)' }}
                    >
                        {
                            notificationList.length === 0
                                ?
                                <span>No new notifications.</span>
                                :
                                <>
                                    {
                                        sortedIdArray?.map((id) => {
                                            let notification = notificationList[id];
                                            if (notification) {
                                                const firstChars = getFirstCharOfWords(notification.userName);
                                                return (
                                                    <div key={notification.uniqueId} className={`mb-2 p-3 d-flex ${!notification.isRead ? 'light-grey-fill' : ''}`} style={{ borderRadius: '0.8rem', cursor: 'pointer', backgroundColor: selectedIdArray.includes(notification.uniqueId) ? "rgba(211, 211, 211, 0.7)" : "" }}
                                                        onClick={() => {
                                                            if (!selectedIdArray.includes(notification.uniqueId) && notification.isRead == "false") {
                                                                apiCallToUpdateWebNotification(notification.uniqueId);
                                                            }
                                                        }}
                                                        disabled={selectedIdArray.includes(notification.uniqueId)}
                                                    >
                                                        <span
                                                            className="mt-2 mr-3 p-1 d-flex align-items-center justify-content-center bg-primary"
                                                            style={{ height: '30px', width: '30px', borderRadius: '50%' }}
                                                            title={notification.userName}
                                                        >
                                                            {firstChars}
                                                        </span>

                                                        <div className="w-75 flex-grow-1 d-flex flex-column" style={{ fontSize: '13px' }}>
                                                            <span>
                                                                {notification.notificationText}
                                                            </span>
                                                            <div className="mt-1 d-flex justify-content-between">
                                                                <span className="font-weight-bold">{notification.moduleName}</span>
                                                                <span className="text-black-50" style={{ fontSize: '12px' }}>
                                                                    {notification.addedOnDateTime}&nbsp;
                                                                    <img src={notification.isRead == "false" ? CHECK : DOUBLE_CHECK} alt="" />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })
                                    }
                                    {
                                        isLoading
                                            ?
                                            (<span className="align-self-center font-weight-bold text-black-50">
                                                Loading more . . .&nbsp;
                                                <FontAwesomeIcon icon={['fas', 'circle-notch']} className="rotate" />
                                            </span>)
                                            :
                                            <>
                                                {totalCount != sortedIdArray.length &&
                                                    <span
                                                        className="align-self-center font-weight-bold ui-link"
                                                        onClick={() => limit >= 10 && loadMore()}
                                                    >Load more</span>}
                                            </>
                                    }
                                </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NotificationPanel;
